<template>
  <div>
    <!-- OVERLAY FOR MOBILE  -->
    <overlay :show="showOverlay" :prevent-scroll="isCheckinDetail" @click="close"/>

    <b-dropdown :dropleft="dropleft" :right="right" variant="link"
                :menu-class="'context-menu dropdown-custom__menu ' + extraMenuClass"
                toggle-class="btn-event-options ml-2 text-decoration-none"
                class="dropdown-custom"
                ref="checkin-menu"
                @shown="onShow"
                @hidden="onHide"
                no-caret>
      <template #button-content>
        <Icon name="dotsVertical" :class="iconClass" :width="iconSize"/>
      </template>

      <div v-touch:swipe.bottom="close">
        <template v-if="isCheckinDetail">
          <b-dropdown-text class="d-md-none event">
            <div>
              <a href="#" class="mobile-closer" @click.prevent="close()">
                <div class="line"></div>
              </a>

              <div class="d-flex align-items-center event-header">
                <div class="event-logo" v-if="eventCover">
                  <img :src="eventCover" alt="Event logo">
                </div>
                <div>
                  <h1 class="event-name">{{ eventName }}</h1>
                </div>
              </div>
            </div>

          </b-dropdown-text>
          <b-dropdown-divider class="d-md-none"/>
        </template>
        <!-- CHECKIN CODE -->
        <b-dropdown-text>
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-nowrap">
              {{ $t('pages.checkins.pica_code') }}: <span class="code">{{ checkin.picacode }}</span>
            </div>
            <div>
              <b-button size="sm" @click.prevent="copy(checkin.picacode)" class="btn-copy ml-2">
                <div class="text-nowrap">
                  <Icon name="copy" :width="18" class="mr-1" vertical-align="sub"/>
                  {{ $t('pages.checkins_detail.btn_copy') }}
                </div>
              </b-button>
            </div>
          </div>

        </b-dropdown-text>

        <!-- CHECKIN QR CODE -->
        <b-dropdown-item href="#" @click.prevent="$emit('show-qr-picacode')" v-if="checkin.show_qrcode">
          <Icon name="qrCode" :width="18" class="mr-1" vertical-align="sub"/>
          {{ $t('pages.checkins_detail.btn_show_qr_picacode') }}
        </b-dropdown-item>

        <!-- DOWNLOAD CHECKIN -->
        <b-dropdown-item href="#" @click.prevent="downloadAlbum" v-if="checkin.can_download_album">
          <Icon name="download" :width="18" class="mr-1" vertical-align="sub"/>
          {{ $t('pages.checkins_detail.btn_download_album') }}
        </b-dropdown-item>

        <!-- ANONYMIZE CHECKIN -->
        <template v-if="checkinAnonymizeStatus !== ANONYMIZATION_STATUS.unavailable">
          <b-dropdown-item href="#" @click.prevent="onAnonymize"
                           :disabled="checkinAnonymizeStatus === ANONYMIZATION_STATUS.pending">
            <div class="d-flex flex-column event-summary__anonymize">
              <div class="d-flex align-items-center justify-content-between">
                <div class="mr-2 pt-1">
                  <Icon name="faceHappy" :width="18" vertical-align="sub" class="mr-1"/>
                  {{ $t('pages.checkins_detail.btn_anonymize') }}
                </div>
                <b-form-checkbox :disabled="checkinAnonymizeStatus === ANONYMIZATION_STATUS.pending"
                                 size="lg"
                                 :checked="checkinAnonymizeStatus === ANONYMIZATION_STATUS.completed"
                                 name="check-button" switch/>
              </div>
            </div>
          </b-dropdown-item>
          <b-dropdown-text class="hint">
            <template v-if="checkinAnonymizeStatus === ANONYMIZATION_STATUS.available">
              {{ $t('pages.checkins_detail.anonymous_mode_off_hint', {'eventName': eventName}) }}
            </template>
            <template v-if="checkinAnonymizeStatus === ANONYMIZATION_STATUS.completed">
              {{ $t('pages.checkins_detail.anonymous_mode_on_hint') }}
            </template>
            <template v-if="checkinAnonymizeStatus === ANONYMIZATION_STATUS.pending">
              {{ $t('pages.checkins_detail.btn_anonymize_pending') }}
            </template>
          </b-dropdown-text>
        </template>

        <!-- REMOVE CHECKIN -->
        <b-dropdown-item href="#" @click.prevent="$emit('remove-album')">
          <Icon name="trash" :width="18" vertical-align="sub" class="mr-1"/>
          {{ $t('pages.checkins_detail.btn_remove_album') }}
        </b-dropdown-item>
        <b-dropdown-text class="hint" v-if="showDeleteHelpText">
          {{ $t('pages.checkins_detail.btn_remove_album_help') }}
        </b-dropdown-text>
      </div>
    </b-dropdown>
  </div>
</template>

<script>

import {ANONYMIZATION_STATUS} from "@/components/ModalAnonymizeCheckin.vue";
import EventService from "@/services/Event";
import Overlay from "@/components/interface/fragments/Overlay.vue";
import {mapGetters} from "vuex";

export default {
  name: "CheckinMenu",
  components: {Overlay},

  data() {
    return {
      showOverlay: false,
    }
  },

  props: {
    checkin: {
      type: Object,
      required: true,
    },
    iconSize: {
      type: Number,
      default: 33,
    },
    iconClass: {
      type: String,
      default: '',
    },
    dropleft: {
      type: Boolean,
      default: false,
    },
    right: {
      type: Boolean,
      default: false,
    },
    isCheckinDetail: {
      type: Boolean,
      default: false,
    },
    showAnonymize: {
      type: Boolean,
      default: true,
    },

  },

  computed: {
    ...mapGetters('checkinDetail', ['picaCode']),
    showDeleteHelpText() {
      return this.checkin && this.checkin.has_checkin_faces
    },
    ANONYMIZATION_STATUS() {
      return ANONYMIZATION_STATUS
    },
    checkinAnonymizeStatus() {
      return this.checkin.anonymize_status
    },
    checkinId() {
      return this.checkin.checkin_id || this.checkin.id
    },
    extraMenuClass() {
      return this.isCheckinDetail ? 'is-checkin' : ''
    },
    eventName() {
      return this.checkin.event_name || (this.checkin.pica_service && this.checkin.pica_service.event_name)
    },
    eventCover() {
      return  this.checkin.event_cover || (this.checkin.pica_service && this.checkin.pica_service.event_cover)
    },
  },

  methods: {
    onShow() {
      this.showOverlay = true
    },
    onHide() {
      this.showOverlay = false
    },
    close() {
      this.$refs['checkin-menu'].hide()
    },
    onAnonymize() {
      this.$emit('anonymize-album', {picacode: this.checkin.picacode})
    },
    downloadAlbum() {
      EventService.downloadAlbum(this.checkinId)
          .then(response => {
            this.$bvToast.toast(
                this.$t('toast_download_album.text'),
                {
                  title: this.$t('toast_download_album.title'),
                  headerClass: 'd-block pt-2',
                  noCloseButton: false,
                  autoHideDelay: 5000
                })
          })
          .catch(error => {
            if (error.response.status === 400 &&
                (error.response.data.code === 'bulk_download_not_available' || error.response.data.code === 'bulk_download_missing_hd')) {
              this.$bvToast.toast(
                  this.$t('toast_download_album.error'),
                  {variant: 'warning', autoHideDelay: 8000, html: true})
            }
          })
    },
    copy(value) {
      navigator.clipboard.writeText(value)
      this.$bvToast.toast(this.$t('notifications.text_copied'))
    }
  },
}
</script>
